import React, { useEffect, useState } from 'react';
import { getAllPatients, getAllAppointments } from '../api';
import { useNavigate } from 'react-router-dom';
import styles from './Page.module.css';
import { useAuth } from '../AuthContext';

export default function PatientsPage() {
  const [patients, setPatients] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { user } = useAuth();
  const isDoctor = user?.role === 'DOCTOR';

  useEffect(() => {
    const fetchPatients = async () => {
      if (isDoctor) {
        // Get all appointments, filter by this doctor, extract unique patients
        const apptRes = await getAllAppointments();
        const myAppointments = apptRes.data.filter(a => a.doctor?.id === user.doctorId);
        const uniquePatients = [];
        const seenIds = new Set();
        myAppointments.forEach(a => {
          if (a.patient && !seenIds.has(a.patient.id)) {
            seenIds.add(a.patient.id);
            uniquePatients.push(a.patient);
          }
        });
        setPatients(uniquePatients);
      } else {
        const r = await getAllPatients();
        setPatients(r.data);
      }
      setLoading(false);
    };
    fetchPatients();
  }, []);

  const filtered = patients.filter(p =>
    search === '' ||
    p.name?.toLowerCase().includes(search.toLowerCase()) ||
    p.phone?.includes(search)
  );

  return (
    <div>
      <h2 className={styles.heading}>
        {isDoctor ? 'My Patients' : 'Patients'}
      </h2>

      <div className={styles.searchBar}>
        <input
          placeholder="Search by name or phone..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>

      <div className={styles.card}>
        {loading ? (
          <p style={{ textAlign: 'center', padding: 20 }}>Loading...</p>
        ) : (
          <table className={styles.table}>
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Phone</th>
                <th>Age</th>
                <th>Gender</th>
                <th>Email</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr>
                  <td colSpan={7} style={{ textAlign: 'center', padding: 20, color: '#888' }}>
                    {isDoctor ? 'No patients assigned to you yet' : 'No patients found'}
                  </td>
                </tr>
              ) : filtered.map((p, i) => (
                <tr key={p.id}>
                  <td>{i + 1}</td>
                  <td><strong>{p.name}</strong></td>
                  <td style={{ color: '#1a3a6b', fontWeight: 500 }}>{p.phone}</td>
                  <td>{p.age}</td>
                  <td>{p.gender}</td>
                  <td>{p.email || '-'}</td>
                  <td>
                    <button className={styles.editBtn}
                      onClick={() => navigate(`/patients/${p.id}`)}>
                      View History
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
